/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

/**
 * The accountType field specifies the type of card account to create. This field is used to distinguish between two types of card accounts: asset-link and prepaid.

An `asset-link` card account is backed by combined asset value from a an associated account, which determines the available credit limit of the card account. Repayment on this type of account is settled through the backing account automatically through asset repayments.

A `prepaid` card account, on the other hand, is pre-funded directly by a top-up action. This operates as a prepaid or pre-funded card model.

A `fixed-limit` card account has a predetermined credit limit that remains unchanged and is not affected by the value of any associated assets. Repayments on this type of account are settled through alternative methods rather than asset repayments.

Please note that the accountType field cannot be changed after the card account has been created.
 */
export type CreateCardAccountBodyAccountType = typeof CreateCardAccountBodyAccountType[keyof typeof CreateCardAccountBodyAccountType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCardAccountBodyAccountType = {
  'asset-link': 'asset-link',
  prepaid: 'prepaid',
  'fixed-limit': 'fixed-limit',
} as const;
